import { FiHome, FiTrendingUp } from "react-icons/fi";
import { RxDashboard } from "react-icons/rx";

export const iconMapping = {
  FiHome: FiHome,
  FiTrendingUp: FiTrendingUp,
  RxDashboard: RxDashboard,
  // Add other icons as needed
};

export const ipsItems = [
  { name: "Home", icon: FiHome, url: "/home", subItems: [] },
  { name: "Dashboard", icon: RxDashboard, url: "/dashboard", subItems: [] },
  // {
  //   name: "Reports",
  //   icon: FiTrendingUp,
  //   url: "/reports",
  //   subItems: [],
  // },
];

export const getLinkItemsForRole = (role) => {
  let linkItems = [];
  const validRoles = ["IPS", "IPS Executive", "IPS Manager", "IPS Head"];

  if (validRoles.includes(role)) {
    linkItems = [...linkItems, ...ipsItems];
  }
  return linkItems;
};
